import React, { memo } from "react";
import { v4 as uuid } from "uuid";
import success from "../../images/alert/Frame 28433.svg";
import error from "../../images/alert/Group 28433.svg";

let style =
   window.innerWidth > 768
      ? {
           color: "#17182d",
           background: "rgba(242, 242, 242, 1)",
           boxShadow: "0px 4px 40px rgba(0, 0, 0, 0.25)",
           width: "450px",
           minHeight: "65px",
           fontWeight: "500",
           paddingRight: "10px",
        }
      : {
           color: "#17182d",
           background: "rgba(242, 242, 242, 1)",
           boxShadow: "0px 4px 40px rgba(0, 0, 0, 0.25)",
           width: "100%", // Full width on small screens
           minHeight: "50px", // Reduce height for small screens
           fontWeight: "500",
           paddingRight: "8px", // Adjust padding
        };

export const defaultToastProps = {
   position: "top-center",
   autoClose: 3000,
   hideProgressBar: true,
   closeOnClick: true,
   closeButton: false,
   pauseOnHover: true,
   toastId: uuid(),
};

function ToastView(props) {
   // type => success/error/info/warning
   const { type = "success", text = "" } = props;
   const isSuccess = type === "success";
   return (
      <div style={style} className="toast-view round-border-l flex-center justify-content-start">
         <img className="ml-4 mr-3" src={isSuccess ? success : error} alt="" />
         <div className={`h3 m-0 p-2`}>{text}</div>
      </div>
   );
}

export default memo(ToastView);
